import React from 'react';
import { Card } from '../ui/Card';
import { BookOpenIcon, MoonStarIcon, ClockIcon, UtensilsIcon, ActivityIcon } from 'lucide-react';
export function DeliverablesSection() {
  const deliverables = [{
    icon: <BookOpenIcon className="w-6 h-6 text-gold" data-id="element-101" />,
    title: 'Guía Principal: Metabolismo Silver 21',
    description: 'El paso a paso de 21 días para dominar tus hormonas y recuperar tu energía.'
  }, {
    icon: <MoonStarIcon className="w-6 h-6 text-gold" data-id="element-102" />,
    title: 'Protocolo Nocturno',
    description: 'La rutina exacta de 10 minutos para bajar el cortisol antes de apagar la luz.'
  }, {
    icon: <ClockIcon className="w-6 h-6 text-gold" data-id="element-103" />,
    title: 'Plan de Micro-Ayunos',
    description: 'Cómo ayunar 10 horas sin pasar hambre y sin generar estrés metabólico.'
  }, {
    icon: <UtensilsIcon className="w-6 h-6 text-gold" data-id="element-104" />,
    title: 'Recetario Anti-Cortisol',
    description: 'Cenas rápidas y deliciosas que promueven el sueño profundo y la quema de grasa.'
  }, {
    icon: <ActivityIcon className="w-6 h-6 text-gold" data-id="element-105" />,
    title: 'Guía de Movimiento Sin Impacto',
    description: 'Ejercicios suaves que tonifican sin agotar tus glándulas adrenales.'
  }];
  return <section className="py-20 bg-beige-light" data-id="element-106">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="text-center mb-16" data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-109">
            Todo lo que necesitas para triunfar
          </h2>
          <p className="text-lg text-taupe-light font-body" data-id="element-110">
            Un sistema completo, fácil de seguir y diseñado para tu estilo de
            vida.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-111">
          {deliverables.map((item, index) => <Card key={index} variant="elevated" className="p-8 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300" data-id="element-112">
              <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center mb-6" data-id="element-113">
                {item.icon}
              </div>
              <h3 className="font-heading text-xl font-bold text-taupe mb-3" data-id="element-114">
                {item.title}
              </h3>
              <p className="font-body text-taupe-light" data-id="element-115">{item.description}</p>
            </Card>)}
        </div>
      </div>
    </section>;
}